import {message} from '@common/i18n/message';
import {MessageDescriptor} from '@common/i18n/message-descriptor';

export interface BusinessCardTemplate {
  id: string;
  label: MessageDescriptor;
  description: MessageDescriptor;
}

export const BusinessCardTemplates: BusinessCardTemplate[] = [
  {
    id: 'classic',
    label: message('Classic'),
    description: message('Photo and name side by side in the header'),
  },
  {
    id: 'hero-photo',
    label: message('Hero Photo'),
    description: message('Large header with your photo overlapping the body'),
  },
  {
    id: 'centered',
    label: message('Centered'),
    description: message('Everything centered, minimal color'),
  },
  {
    id: 'minimal-strip',
    label: message('Minimal Strip'),
    description: message('Compact card with a thin accent bar'),
  },
  {
    id: 'sidebar-split',
    label: message('Sidebar Split'),
    description: message('Colored sidebar next to your contact details'),
  },
];

export const DefaultBusinessCardTemplateId = 'classic';
